import React from "react";
import BucketMinibarWrapper from "./BucketMinibarWrapper";
import Box from "@mui/material/Box";

const BucketMinibar = () => {
  return (
    <BucketMinibarWrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 1.5,
        }}
      >
        <Box
          sx={{
            height: { xs: 40, sm: 40 },
            width: { xs: 40, sm: 40 },
            ml: 2.2,
            mt: 2.2,
          }}
        ></Box>
      </Box>
    </BucketMinibarWrapper>
  );
};

export default BucketMinibar;
